import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(
    private toastr: ToastrService,
    private transloco: TranslocoService
  ) {
    this.toastr.toastrConfig
  }

  showSuccess(message: string, title?: string): void {
    this.toastr.success(
      message,
      title ?? this.transloco.translate('notification_success_title')
    );
  }

  showError(message: string, title?: string): void {
    this.toastr.error(
      message,
      title ?? this.transloco.translate('notification_error_title')
    );
  }

  showInfo(message: string, title: string): void {
    this.toastr.info(message, title);
  }

  showWarning(message: string, title: string): void {
    this.toastr.warning(message, title);
  }
}
